// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /inbox/get-unread-count.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeInboxGetUnreadCountBody,
  typeInboxGetUnreadCountOutput200,
} from "../../sdk/inbox/postInboxGetUnreadCount";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildInboxGetUnreadCountQueryKey(
  payload: typeInboxGetUnreadCountBody,
): string[] {
  const queryKeySegments: string[] = [];

  return [
    "post:inbox:inboxGetUnreadCount",
    "svc:notification-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeInboxGetUnreadCountOutput200,
    unknown,
    typeInboxGetUnreadCountOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useInboxGetUnreadCount(
  payload: typeInboxGetUnreadCountBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildInboxGetUnreadCountQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postInboxGetUnreadCount(payload),
    ...resolvedOptions,
  });
}
